import { TypedUseSelectorHook } from 'react-redux';
import store from './store';

export { useAppDispatch, useAppSelector } from './hooks';

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppSelector = TypedUseSelectorHook<AppState>;

export default store;
